import styled from "styled-components";

export const StyledNotificationBannerWrapper = styled.div`
    margin-top: 8px;
`;
